import { CruiseDay, ItineraryResponse } from '@msc-b2c/interfaces/types';
import { replacePlaceholders } from '@msc-b2c/shared-utils';

const normalizeCardDate = (value?: string): string => {
  const trimmed = value?.trim() ?? '';
  return trimmed.length >= 10 ? trimmed.slice(0, 10) : trimmed;
};

export function buildTextFromItinerary(
  itineraryData: ItineraryResponse | null | undefined,
  day: string | number | undefined,
  portCode: string | undefined,
  startDate: string | undefined,
  dayAtSeaLabelValue: string | undefined,
  text: string
) {
  let portName: string | undefined = '';
  const normalizedStartDate = normalizeCardDate(startDate);

  if (itineraryData && day && portCode && normalizedStartDate) {
    itineraryData.days.forEach((itineraryDay: CruiseDay) => {
      if (
        normalizeCardDate(itineraryDay.date) === normalizedStartDate &&
        itineraryDay.port.code === portCode
      ) {
        portName = itineraryDay.port.name;
      } else if (portCode === 'ATC') {
        portName = dayAtSeaLabelValue;
      }
    });
    text = text.includes('{dayNumber}')
      ? replacePlaceholders(text, { dayNumber: String(day) })
      : text;
    text = text.includes('{portName}') ? replacePlaceholders(text, { portName: portName }) : text;
  }
  return text;
}
